import styled, { css } from 'styled-components'
import { Icon, Image } from 'semantic-ui-react'
import { Primary } from '..'

export const Wrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  position: absolute;
  backdrop-filter: blur(5px) contrast(0.8);
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
`

export const Main = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  width: 90vw;
  max-width: 400px;
  background: black;
  padding: 2em 0;
  color: ${({ theme }) => theme.colors.white};
  text-align: center;
  margin-top: 4em;
`

export const Container = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  padding: ${props => (props.padded ? '1em' : '0')};
  ${props =>
    props.info &&
    css`
      padding: 0 2em 2em 2em;
    `}
`

export const StyledSpan = styled.span`
  color: ${({ theme }) => theme.colors.white};
  margin: 5px 0;
  ${props =>
    props.bolder &&
    css`
      font-weight: bolder;
      font-size: 1.4em;
    `}
  ${props =>
    props.bold &&
    css`
      font-weight: bold;
      margin-bottom: 1em;
    `}
  ${props =>
    props.emphasized &&
    css`
      font-style: italic;
    `}
`

export const IgniteImage = styled(Image)`
  &&& {
    width: 100%;
    height: auto;
    max-width: 400px;
    margin-bottom: 2em;
  }
`

export const QLogo = styled(Image)`
  &&& {
    width: 50%;
    height: auto;
    max-width: 200px;
  }
`

export const CloseButton = styled(Primary)`
  box-shadow: none !important;
`

export const InfoIcon = styled(Icon)`
  color: ${({ theme }) => theme.colors.skyBlue};
`

export const StyledLink = styled.span`
  font-weight: bold;
  font-size: ${props => (props.small ? '1em' : '1.5em')};
  margin-top: 10px;
  color: ${({ theme }) => theme.colors.linkBlue};
  text-decoration: none;
  cursor: pointer;

  :hover {
    color: ${({ theme }) => theme.colors.sapphireBlue};
  }
`
